module.exports = __webpack_public_path__ + "img/bedroom-lighting.d8805c3.jpg";